const ITEMS = [
  { n: "01", t: "Think clearly" },
  { n: "02", t: "Solve real problems" },
  { n: "03", t: "Work with others" },
  { n: "04", t: "Lead with purpose" },
];

const Group = () => (
  <div className="mq-group">
    {ITEMS.map((item) => (
      <div className="mq-item" key={item.n}>
        <b>{item.n}</b> {item.t} <span className="mq-dot">◆</span>
      </div>
    ))}
    <div className="mq-item">
      KOSS 2027 · OSOGBO <span className="mq-dot">◆</span>
    </div>
    <div className="mq-item mq-theme">
      “Strategies for Impact and Innovation” <span className="mq-dot">◆</span>
    </div>
  </div>
);

export default function Marquee() {
  return (
    <div className="marquee" data-testid="gold-marquee-strip" aria-hidden="true">
      <div className="marquee-track">
        <Group />
        <Group />
        <Group />
        <Group />
      </div>
    </div>
  );
}
